
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PageBuilderItemProps } from ".";
import { loading, create } from "store/role";
import { AppMessage } from "components";

interface ApiPageBuilderCreateInputProps extends Omit<PageBuilderItemProps, "id"> {
}

type ApiPageBuilderCreateOutputProps = OutputBaseProps<{ item: PageBuilderItemProps; }, ApiPageBuilderCreateInputProps>

export const apiPageBuilderCreate = async (data: ApiPageBuilderCreateInputProps) => {
    const res = (await axios.post<ApiPageBuilderCreateOutputProps>("/api/page-builder/create", data))
        .data;
    if (res.code === 0 && res.data) {
        // store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};